/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgPmiGroup = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M12.63 12.721v-1.008h3.584v4.872a6.197 6.197 0 0 1-1.554.504 8.643 8.643 0 0 1-1.778.182c-1.67 0-2.94-.453-3.808-1.358-.859-.915-1.288-2.259-1.288-4.032 0-1.083.21-2.007.63-2.772a4.277 4.277 0 0 1 1.806-1.764c.793-.41 1.745-.616 2.856-.616a6.7 6.7 0 0 1 1.316.126c.43.075.821.191 1.176.35v1.484a8.392 8.392 0 0 0-1.274-.336 5.982 5.982 0 0 0-1.148-.112c-1.148 0-2.035.317-2.66.952-.616.625-.924 1.521-.924 2.688 0 2.576 1.12 3.864 3.36 3.864.541 0 1.087-.056 1.638-.168v-2.338l-1.932-.518z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgPmiGroup as PmiGroup };
